import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiDataService } from '@core/services/api/api-data.service';


@Injectable({
  providedIn: 'root'
})
export class ApiGlobalSearchService extends ApiDataService {
  protected apiUrl = 'client/global-search';

  getGlobalSearchPageUrl(): Observable<{ url: string }> {
    const url = this.apiUrlService.getApiUrl() + 'client/get-global-search-page-url';
    return this.httpClient.get<{ url: string }>(url);
  }
}
